export default __webpack_public_path__ + "static/media/discover_blank.d1b20589.png";